import { Language, PartialLabelData } from '../../api';

// Default consent wording, offered so a merchant enabling card-saving starts from something
// workable instead of a blank field. It is a starting point, not a legal opinion -- merchants
// are expected to edit it, and the field stays required so they cannot ship an empty checkbox.
//
// These are customer-facing strings keyed by the *customer's* language, so they deliberately
// do not go through i18next (which follows the admin's own UI language).
const ORDER_CONSENT: Record<Language, string> = {
  [Language.EN]:
    'I agree to securely save my card details, so the business can charge the remaining balance or ' +
    'additional payments for this booking.',
  [Language.HE]:
    'אני מאשר/ת לשמור את פרטי הכרטיס שלי באופן מאובטח, כדי שהעסק יוכל לחייב את יתרת התשלום או ' +
    'תשלומים נוספים עבור הזמנה זו.',
};

const PASS_CONSENT: Record<Language, string> = {
  [Language.EN]: 'I agree to securely save my card details, so I can buy  again later without re-entering them.',
  [Language.HE]: 'אני מאשר/ת לשמור את פרטי הכרטיס שלי באופן מאובטח, כדי שאוכל לרכוש שוב בלי להזין אותם מחדש.',
};

export enum SaveCardConsentVariant {
  ORDER = 'order',
  PASS = 'pass',
}

// Fills in a default per language, keeping anything the merchant already wrote. Partial
// labels are filled per-language rather than all-or-nothing, so adding a new customer-facing
// language does not leave that one blank.
export const withDefaultSaveCardLabel = (
  existing: PartialLabelData | undefined,
  languages: Language[] | undefined,
  variant: SaveCardConsentVariant,
): PartialLabelData => {
  const defaults = variant === SaveCardConsentVariant.PASS ? PASS_CONSENT : ORDER_CONSENT;
  const filled: PartialLabelData = { ...(existing || {}) };

  (languages || []).forEach((language) => {
    if (!filled[language]?.trim()) {
      filled[language] = defaults[language] || defaults[Language.EN];
    }
  });

  return filled;
};
